import * as htmltoimage from "html-to-image";

// import html2canvas from 'html2canvas';

// main function
const buildPngDataURL = (element: HTMLElement): Promise<string | void> => {
  return new Promise(async (resolve, reject) => {
    // svg 이미지를 만든다.
    if (element) {
      // const imageContentsList = element.querySelectorAll(
      //   ".image-contents-list"
      // );

      const elementWidth = element.clientWidth;
      const elementHeight = element.clientHeight;

      element.style.setProperty("width", `${elementWidth}px`);
      element.style.setProperty("height", `${elementHeight}px`);

      // 배경을 제외한 모든 이미지엘리먼트를 보이지 않게 한다. TEXT 형태의 엘리먼트만 렌더링 하고자 한다.
      // tslint:disable-next-line:prefer-for-of
      // for (let i = 0; i < imageContentsList.length; i++) {
      //   const currentDiv = imageContentsList[i] as HTMLDivElement;
      //   currentDiv.style.setProperty("display", "none");
      // }

      // 메인이미지를 가져와서 정보를 조사하고 배경div 에 값을 세팅하여 레이아웃을 유지한후에 이미지를 감춘다.
      // const backgroundImage = document.getElementById(
      //   `bg_img_${element.id}`
      // ) as HTMLImageElement;

      // backgroundImage.style.setProperty("display", "none");

      // const textCanvas: HTMLCanvasElement = await htmltoimage.toCanvas(
      //   element,
      //   { width: elementWidth, height: elementHeight }
      // );

      // document.body.append(textCanvas);

      // const textLayer = textCanvas.toDataURL();

      // tslint:disable-next-line:prefer-for-of
      // for (let i = 0; i < imageContentsList.length; i++) {
      //   const currentDiv = imageContentsList[i] as HTMLDivElement;
      //   currentDiv.style.setProperty("display", "block");
      // }

      // backgroundImage.style.setProperty("display", "block");

      // element.style.setProperty("width", `${elementWidth}px`);
      // element.style.setProperty("height", `${elementHeight}px`);

      window.scrollTo(0, 0);

      await htmltoimage.toPng(element);
      await htmltoimage.toPng(element);
      await htmltoimage.toPng(element);

      const pngStream = await htmltoimage.toPng(element);

      // 이미지 퀄리티 문제만 해결하면 된다.
      // 옵션을 조합해 보면서 생성해보자.

      resolve(pngStream);
    }
  });
};

const screenshot = {
  buildPngDataURL,
};

export default screenshot;



// WEBPACK FOOTER //
// ./src/util/screenshot.ts